import React from "react";
import { ListItem, ListItemHeader } from "./notification-list-item.styles";
import moment from "moment";
import { markNotificationAsRead } from "../../../../redux/actions/notificationsActions";
import cx from "classnames";
import { useDispatch } from "react-redux";
import { NotificationListItemProps } from "./notification-list-item.props";
import { Heading } from "../../../../components/headers/heading/heading.component";
import { INotification } from "../../../../types/notification/inotification.interface";
import * as navigationService from "../../../navigation/services/navigation.service";

export const NotificationListItem: React.FC<NotificationListItemProps> = ({ items, onClose }) => {
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setMilliseconds(0);
  const dispatch = useDispatch();

  const handleMarkAsRead = (notification: INotification) => {
    if (notification.unread) {
      dispatch(markNotificationAsRead(notification.id));
    }
  };

  const navigateToResource = (
    notification: INotification,
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (!notification.target) {
      return;
    }
    onClose(event);
    navigationService.navigateToNotificationResource(notification);
  };

  return (
    <>
      {items.map((item) => (
        <ListItem
          tabIndex={0}
          className={cx({ unread: item.unread })}
          onKeyPress={(e: React.KeyboardEvent) => {
            handleMarkAsRead(item);
            if (e.key === "Enter") {
              navigateToResource(item, e);
            }
          }}
          onClick={(e: React.MouseEvent) => {
            handleMarkAsRead(item);
            navigateToResource(item, e);
          }}
          key={item.id}
        >
          <ListItemHeader>
            <Heading variant="sub">{item.target ? item.target.name : "Update"}</Heading>
            {moment(item.timestamp).isAfter(today) && (
              <>
                {`${moment(item.timestamp).format("h:mm")} ${
                  moment(item.timestamp).hours() >= 12 ? "PM" : "AM"
                }`}
              </>
            )}
            {!moment(item.timestamp).isAfter(today) && (
              <>{moment(item.timestamp).format("MMM D")}</>
            )}
          </ListItemHeader>
          <p>{item.description}</p>
        </ListItem>
      ))}
    </>
  );
};
